/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as GuestImport } from './routes/_guest'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as IndexImport } from './routes/index'
import { Route as AuthenticatedIndexCopyImport } from './routes/_authenticated/index-copy'
import { Route as AuthenticatedCalendarIndexImport } from './routes/_authenticated/calendar/index'
import { Route as GuestAuthMagicLinkImport } from './routes/_guest/auth/magic-link'
import { Route as GuestAuthLoginImport } from './routes/_guest/auth/login'
import { Route as AuthenticatedSettingsUsersIndexImport } from './routes/_authenticated/settings/users/index'
import { Route as AuthenticatedSettingsAttributesIndexImport } from './routes/_authenticated/settings/attributes/index'
import { Route as AuthenticatedSettingsAttributeGroupsIndexImport } from './routes/_authenticated/settings/attribute-groups/index'
import { Route as AuthenticatedDocumentsUploadIndexImport } from './routes/_authenticated/documents/upload/index'
import { Route as AuthenticatedDocumentsProcessingIndexImport } from './routes/_authenticated/documents/processing/index'
import { Route as AuthenticatedDocumentsBrowseIndexImport } from './routes/_authenticated/documents/browse/index'
import { Route as AuthenticatedDocumentsDocumentIdIndexImport } from './routes/_authenticated/documents/$documentId/index'
import { Route as AuthenticatedSettingsAttributesCreateIndexImport } from './routes/_authenticated/settings/attributes/create/index'
import { Route as AuthenticatedSettingsAttributeGroupsCreateIndexImport } from './routes/_authenticated/settings/attribute-groups/create/index'
import { Route as AuthenticatedSettingsAttributesEditAttributeIdImport } from './routes/_authenticated/settings/attributes/edit/$attributeId'
import { Route as AuthenticatedSettingsAttributeGroupsEditAttributeGroupIdImport } from './routes/_authenticated/settings/attribute-groups/edit/$attributeGroupId'

// Create/Update Routes

const GuestRoute = GuestImport.update({
  id: '/_guest',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexCopyRoute = AuthenticatedIndexCopyImport.update({
  id: '/index-copy',
  path: '/index-copy',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedCalendarIndexRoute = AuthenticatedCalendarIndexImport.update(
  {
    id: '/calendar/',
    path: '/calendar/',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const GuestAuthMagicLinkRoute = GuestAuthMagicLinkImport.update({
  id: '/auth/magic-link',
  path: '/auth/magic-link',
  getParentRoute: () => GuestRoute,
} as any)

const GuestAuthLoginRoute = GuestAuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => GuestRoute,
} as any)

const AuthenticatedSettingsUsersIndexRoute =
  AuthenticatedSettingsUsersIndexImport.update({
    id: '/settings/users/',
    path: '/settings/users/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedSettingsAttributesIndexRoute =
  AuthenticatedSettingsAttributesIndexImport.update({
    id: '/settings/attributes/',
    path: '/settings/attributes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedSettingsAttributeGroupsIndexRoute =
  AuthenticatedSettingsAttributeGroupsIndexImport.update({
    id: '/settings/attribute-groups/',
    path: '/settings/attribute-groups/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedDocumentsUploadIndexRoute =
  AuthenticatedDocumentsUploadIndexImport.update({
    id: '/documents/upload/',
    path: '/documents/upload/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedDocumentsProcessingIndexRoute =
  AuthenticatedDocumentsProcessingIndexImport.update({
    id: '/documents/processing/',
    path: '/documents/processing/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedDocumentsBrowseIndexRoute =
  AuthenticatedDocumentsBrowseIndexImport.update({
    id: '/documents/browse/',
    path: '/documents/browse/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedDocumentsDocumentIdIndexRoute =
  AuthenticatedDocumentsDocumentIdIndexImport.update({
    id: '/documents/$documentId/',
    path: '/documents/$documentId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedSettingsAttributesCreateIndexRoute =
  AuthenticatedSettingsAttributesCreateIndexImport.update({
    id: '/settings/attributes/create/',
    path: '/settings/attributes/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedSettingsAttributeGroupsCreateIndexRoute =
  AuthenticatedSettingsAttributeGroupsCreateIndexImport.update({
    id: '/settings/attribute-groups/create/',
    path: '/settings/attribute-groups/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedSettingsAttributesEditAttributeIdRoute =
  AuthenticatedSettingsAttributesEditAttributeIdImport.update({
    id: '/settings/attributes/edit/$attributeId',
    path: '/settings/attributes/edit/$attributeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedSettingsAttributeGroupsEditAttributeGroupIdRoute =
  AuthenticatedSettingsAttributeGroupsEditAttributeGroupIdImport.update({
    id: '/settings/attribute-groups/edit/$attributeGroupId',
    path: '/settings/attribute-groups/edit/$attributeGroupId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_guest': {
      id: '/_guest'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof GuestImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/index-copy': {
      id: '/_authenticated/index-copy'
      path: '/index-copy'
      fullPath: '/index-copy'
      preLoaderRoute: typeof AuthenticatedIndexCopyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_guest/auth/login': {
      id: '/_guest/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof GuestAuthLoginImport
      parentRoute: typeof GuestImport
    }
    '/_guest/auth/magic-link': {
      id: '/_guest/auth/magic-link'
      path: '/auth/magic-link'
      fullPath: '/auth/magic-link'
      preLoaderRoute: typeof GuestAuthMagicLinkImport
      parentRoute: typeof GuestImport
    }
    '/_authenticated/calendar/': {
      id: '/_authenticated/calendar/'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthenticatedCalendarIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/documents/$documentId/': {
      id: '/_authenticated/documents/$documentId/'
      path: '/documents/$documentId'
      fullPath: '/documents/$documentId'
      preLoaderRoute: typeof AuthenticatedDocumentsDocumentIdIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/documents/browse/': {
      id: '/_authenticated/documents/browse/'
      path: '/documents/browse'
      fullPath: '/documents/browse'
      preLoaderRoute: typeof AuthenticatedDocumentsBrowseIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/documents/processing/': {
      id: '/_authenticated/documents/processing/'
      path: '/documents/processing'
      fullPath: '/documents/processing'
      preLoaderRoute: typeof AuthenticatedDocumentsProcessingIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/documents/upload/': {
      id: '/_authenticated/documents/upload/'
      path: '/documents/upload'
      fullPath: '/documents/upload'
      preLoaderRoute: typeof AuthenticatedDocumentsUploadIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings/attribute-groups/': {
      id: '/_authenticated/settings/attribute-groups/'
      path: '/settings/attribute-groups'
      fullPath: '/settings/attribute-groups'
      preLoaderRoute: typeof AuthenticatedSettingsAttributeGroupsIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings/attributes/': {
      id: '/_authenticated/settings/attributes/'
      path: '/settings/attributes'
      fullPath: '/settings/attributes'
      preLoaderRoute: typeof AuthenticatedSettingsAttributesIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings/users/': {
      id: '/_authenticated/settings/users/'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedSettingsUsersIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings/attribute-groups/edit/$attributeGroupId': {
      id: '/_authenticated/settings/attribute-groups/edit/$attributeGroupId'
      path: '/settings/attribute-groups/edit/$attributeGroupId'
      fullPath: '/settings/attribute-groups/edit/$attributeGroupId'
      preLoaderRoute: typeof AuthenticatedSettingsAttributeGroupsEditAttributeGroupIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings/attributes/edit/$attributeId': {
      id: '/_authenticated/settings/attributes/edit/$attributeId'
      path: '/settings/attributes/edit/$attributeId'
      fullPath: '/settings/attributes/edit/$attributeId'
      preLoaderRoute: typeof AuthenticatedSettingsAttributesEditAttributeIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings/attribute-groups/create/': {
      id: '/_authenticated/settings/attribute-groups/create/'
      path: '/settings/attribute-groups/create'
      fullPath: '/settings/attribute-groups/create'
      preLoaderRoute: typeof AuthenticatedSettingsAttributeGroupsCreateIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings/attributes/create/': {
      id: '/_authenticated/settings/attributes/create/'
      path: '/settings/attributes/create'
      fullPath: '/settings/attributes/create'
      preLoaderRoute: typeof AuthenticatedSettingsAttributesCreateIndexImport
      parentRoute: typeof AuthenticatedImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedRouteChildren {
  AuthenticatedIndexCopyRoute: typeof AuthenticatedIndexCopyRoute
  AuthenticatedCalendarIndexRoute: typeof AuthenticatedCalendarIndexRoute
  AuthenticatedDocumentsDocumentIdIndexRoute: typeof AuthenticatedDocumentsDocumentIdIndexRoute
  AuthenticatedDocumentsBrowseIndexRoute: typeof AuthenticatedDocumentsBrowseIndexRoute
  AuthenticatedDocumentsProcessingIndexRoute: typeof AuthenticatedDocumentsProcessingIndexRoute
  AuthenticatedDocumentsUploadIndexRoute: typeof AuthenticatedDocumentsUploadIndexRoute
  AuthenticatedSettingsAttributeGroupsIndexRoute: typeof AuthenticatedSettingsAttributeGroupsIndexRoute
  AuthenticatedSettingsAttributesIndexRoute: typeof AuthenticatedSettingsAttributesIndexRoute
  AuthenticatedSettingsUsersIndexRoute: typeof AuthenticatedSettingsUsersIndexRoute
  AuthenticatedSettingsAttributeGroupsEditAttributeGroupIdRoute: typeof AuthenticatedSettingsAttributeGroupsEditAttributeGroupIdRoute
  AuthenticatedSettingsAttributesEditAttributeIdRoute: typeof AuthenticatedSettingsAttributesEditAttributeIdRoute
  AuthenticatedSettingsAttributeGroupsCreateIndexRoute: typeof AuthenticatedSettingsAttributeGroupsCreateIndexRoute
  AuthenticatedSettingsAttributesCreateIndexRoute: typeof AuthenticatedSettingsAttributesCreateIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexCopyRoute: AuthenticatedIndexCopyRoute,
  AuthenticatedCalendarIndexRoute: AuthenticatedCalendarIndexRoute,
  AuthenticatedDocumentsDocumentIdIndexRoute:
    AuthenticatedDocumentsDocumentIdIndexRoute,
  AuthenticatedDocumentsBrowseIndexRoute:
    AuthenticatedDocumentsBrowseIndexRoute,
  AuthenticatedDocumentsProcessingIndexRoute:
    AuthenticatedDocumentsProcessingIndexRoute,
  AuthenticatedDocumentsUploadIndexRoute:
    AuthenticatedDocumentsUploadIndexRoute,
  AuthenticatedSettingsAttributeGroupsIndexRoute:
    AuthenticatedSettingsAttributeGroupsIndexRoute,
  AuthenticatedSettingsAttributesIndexRoute:
    AuthenticatedSettingsAttributesIndexRoute,
  AuthenticatedSettingsUsersIndexRoute: AuthenticatedSettingsUsersIndexRoute,
  AuthenticatedSettingsAttributeGroupsEditAttributeGroupIdRoute:
    AuthenticatedSettingsAttributeGroupsEditAttributeGroupIdRoute,
  AuthenticatedSettingsAttributesEditAttributeIdRoute:
    AuthenticatedSettingsAttributesEditAttributeIdRoute,
  AuthenticatedSettingsAttributeGroupsCreateIndexRoute:
    AuthenticatedSettingsAttributeGroupsCreateIndexRoute,
  AuthenticatedSettingsAttributesCreateIndexRoute:
    AuthenticatedSettingsAttributesCreateIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface GuestRouteChildren {
  GuestAuthLoginRoute: typeof GuestAuthLoginRoute
  GuestAuthMagicLinkRoute: typeof GuestAuthMagicLinkRoute
}

const GuestRouteChildren: GuestRouteChildren = {
  GuestAuthLoginRoute: GuestAuthLoginRoute,
  GuestAuthMagicLinkRoute: GuestAuthMagicLinkRoute,
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof GuestRouteWithChildren
  '/index-copy': typeof AuthenticatedIndexCopyRoute
  '/auth/login': typeof GuestAuthLoginRoute
  '/auth/magic-link': typeof GuestAuthMagicLinkRoute
  '/calendar': typeof AuthenticatedCalendarIndexRoute
  '/documents/$documentId': typeof AuthenticatedDocumentsDocumentIdIndexRoute
  '/documents/browse': typeof AuthenticatedDocumentsBrowseIndexRoute
  '/documents/processing': typeof AuthenticatedDocumentsProcessingIndexRoute
  '/documents/upload': typeof AuthenticatedDocumentsUploadIndexRoute
  '/settings/attribute-groups': typeof AuthenticatedSettingsAttributeGroupsIndexRoute
  '/settings/attributes': typeof AuthenticatedSettingsAttributesIndexRoute
  '/settings/users': typeof AuthenticatedSettingsUsersIndexRoute
  '/settings/attribute-groups/edit/$attributeGroupId': typeof AuthenticatedSettingsAttributeGroupsEditAttributeGroupIdRoute
  '/settings/attributes/edit/$attributeId': typeof AuthenticatedSettingsAttributesEditAttributeIdRoute
  '/settings/attribute-groups/create': typeof AuthenticatedSettingsAttributeGroupsCreateIndexRoute
  '/settings/attributes/create': typeof AuthenticatedSettingsAttributesCreateIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof GuestRouteWithChildren
  '/index-copy': typeof AuthenticatedIndexCopyRoute
  '/auth/login': typeof GuestAuthLoginRoute
  '/auth/magic-link': typeof GuestAuthMagicLinkRoute
  '/calendar': typeof AuthenticatedCalendarIndexRoute
  '/documents/$documentId': typeof AuthenticatedDocumentsDocumentIdIndexRoute
  '/documents/browse': typeof AuthenticatedDocumentsBrowseIndexRoute
  '/documents/processing': typeof AuthenticatedDocumentsProcessingIndexRoute
  '/documents/upload': typeof AuthenticatedDocumentsUploadIndexRoute
  '/settings/attribute-groups': typeof AuthenticatedSettingsAttributeGroupsIndexRoute
  '/settings/attributes': typeof AuthenticatedSettingsAttributesIndexRoute
  '/settings/users': typeof AuthenticatedSettingsUsersIndexRoute
  '/settings/attribute-groups/edit/$attributeGroupId': typeof AuthenticatedSettingsAttributeGroupsEditAttributeGroupIdRoute
  '/settings/attributes/edit/$attributeId': typeof AuthenticatedSettingsAttributesEditAttributeIdRoute
  '/settings/attribute-groups/create': typeof AuthenticatedSettingsAttributeGroupsCreateIndexRoute
  '/settings/attributes/create': typeof AuthenticatedSettingsAttributesCreateIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_guest': typeof GuestRouteWithChildren
  '/_authenticated/index-copy': typeof AuthenticatedIndexCopyRoute
  '/_guest/auth/login': typeof GuestAuthLoginRoute
  '/_guest/auth/magic-link': typeof GuestAuthMagicLinkRoute
  '/_authenticated/calendar/': typeof AuthenticatedCalendarIndexRoute
  '/_authenticated/documents/$documentId/': typeof AuthenticatedDocumentsDocumentIdIndexRoute
  '/_authenticated/documents/browse/': typeof AuthenticatedDocumentsBrowseIndexRoute
  '/_authenticated/documents/processing/': typeof AuthenticatedDocumentsProcessingIndexRoute
  '/_authenticated/documents/upload/': typeof AuthenticatedDocumentsUploadIndexRoute
  '/_authenticated/settings/attribute-groups/': typeof AuthenticatedSettingsAttributeGroupsIndexRoute
  '/_authenticated/settings/attributes/': typeof AuthenticatedSettingsAttributesIndexRoute
  '/_authenticated/settings/users/': typeof AuthenticatedSettingsUsersIndexRoute
  '/_authenticated/settings/attribute-groups/edit/$attributeGroupId': typeof AuthenticatedSettingsAttributeGroupsEditAttributeGroupIdRoute
  '/_authenticated/settings/attributes/edit/$attributeId': typeof AuthenticatedSettingsAttributesEditAttributeIdRoute
  '/_authenticated/settings/attribute-groups/create/': typeof AuthenticatedSettingsAttributeGroupsCreateIndexRoute
  '/_authenticated/settings/attributes/create/': typeof AuthenticatedSettingsAttributesCreateIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/index-copy'
    | '/auth/login'
    | '/auth/magic-link'
    | '/calendar'
    | '/documents/$documentId'
    | '/documents/browse'
    | '/documents/processing'
    | '/documents/upload'
    | '/settings/attribute-groups'
    | '/settings/attributes'
    | '/settings/users'
    | '/settings/attribute-groups/edit/$attributeGroupId'
    | '/settings/attributes/edit/$attributeId'
    | '/settings/attribute-groups/create'
    | '/settings/attributes/create'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/index-copy'
    | '/auth/login'
    | '/auth/magic-link'
    | '/calendar'
    | '/documents/$documentId'
    | '/documents/browse'
    | '/documents/processing'
    | '/documents/upload'
    | '/settings/attribute-groups'
    | '/settings/attributes'
    | '/settings/users'
    | '/settings/attribute-groups/edit/$attributeGroupId'
    | '/settings/attributes/edit/$attributeId'
    | '/settings/attribute-groups/create'
    | '/settings/attributes/create'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_guest'
    | '/_authenticated/index-copy'
    | '/_guest/auth/login'
    | '/_guest/auth/magic-link'
    | '/_authenticated/calendar/'
    | '/_authenticated/documents/$documentId/'
    | '/_authenticated/documents/browse/'
    | '/_authenticated/documents/processing/'
    | '/_authenticated/documents/upload/'
    | '/_authenticated/settings/attribute-groups/'
    | '/_authenticated/settings/attributes/'
    | '/_authenticated/settings/users/'
    | '/_authenticated/settings/attribute-groups/edit/$attributeGroupId'
    | '/_authenticated/settings/attributes/edit/$attributeId'
    | '/_authenticated/settings/attribute-groups/create/'
    | '/_authenticated/settings/attributes/create/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  GuestRoute: typeof GuestRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  GuestRoute: GuestRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/_guest"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/index-copy",
        "/_authenticated/calendar/",
        "/_authenticated/documents/$documentId/",
        "/_authenticated/documents/browse/",
        "/_authenticated/documents/processing/",
        "/_authenticated/documents/upload/",
        "/_authenticated/settings/attribute-groups/",
        "/_authenticated/settings/attributes/",
        "/_authenticated/settings/users/",
        "/_authenticated/settings/attribute-groups/edit/$attributeGroupId",
        "/_authenticated/settings/attributes/edit/$attributeId",
        "/_authenticated/settings/attribute-groups/create/",
        "/_authenticated/settings/attributes/create/"
      ]
    },
    "/_guest": {
      "filePath": "_guest.tsx",
      "children": [
        "/_guest/auth/login",
        "/_guest/auth/magic-link"
      ]
    },
    "/_authenticated/index-copy": {
      "filePath": "_authenticated/index-copy.tsx",
      "parent": "/_authenticated"
    },
    "/_guest/auth/login": {
      "filePath": "_guest/auth/login.tsx",
      "parent": "/_guest"
    },
    "/_guest/auth/magic-link": {
      "filePath": "_guest/auth/magic-link.tsx",
      "parent": "/_guest"
    },
    "/_authenticated/calendar/": {
      "filePath": "_authenticated/calendar/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/documents/$documentId/": {
      "filePath": "_authenticated/documents/$documentId/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/documents/browse/": {
      "filePath": "_authenticated/documents/browse/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/documents/processing/": {
      "filePath": "_authenticated/documents/processing/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/documents/upload/": {
      "filePath": "_authenticated/documents/upload/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/attribute-groups/": {
      "filePath": "_authenticated/settings/attribute-groups/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/attributes/": {
      "filePath": "_authenticated/settings/attributes/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/users/": {
      "filePath": "_authenticated/settings/users/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/attribute-groups/edit/$attributeGroupId": {
      "filePath": "_authenticated/settings/attribute-groups/edit/$attributeGroupId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/attributes/edit/$attributeId": {
      "filePath": "_authenticated/settings/attributes/edit/$attributeId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/attribute-groups/create/": {
      "filePath": "_authenticated/settings/attribute-groups/create/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/attributes/create/": {
      "filePath": "_authenticated/settings/attributes/create/index.tsx",
      "parent": "/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
